<template>
  <div>
    <Form
      ref="mainForm"
      v-if="mode === 1"
      :model="form"
      :rules="rules1"
      label-position="right"
      :label-width="120"
      style="width: 500px; margin: 0 auto; display: block"
    >
      <FormItem label="企业全称" prop="name">
        <Input v-model="form.name" style="width: 400px" />
      </FormItem>
      <FormItem label="">
        <Button type="primary" @click="checkCompany">点击加入该企业</Button>
      </FormItem>
    </Form>
    <Form
      v-show="mode === 3"
      ref="applyForm"
      :model="applyForm"
      :rules="applyRules"
      label-position="right"
      :label-width="120"
      style="width: 500px; margin: 0 auto; display: block"
    >
      <FormItem label="企业全称" prop="name">
        <Row typle="flex">
          <Col span="18">
            <Input v-model="form.name" style="width: 280px" disabled />
          </Col>
          <Col>
            <Button type="text" @click="mode = 1">修改企业名称</Button>
          </Col>
        </Row>
      </FormItem>
      <FormItem label="我的单位/部门" prop="deparment">
        <Input v-model="applyForm.deparment" style="width: 400px" />
      </FormItem>
      <FormItem label="我的职务" prop="duty">
        <Input v-model="applyForm.duty" style="width: 400px" maxlength="20" />
      </FormItem>
      <FormItem label="工作证件" prop="workCard">
        <Upload
          ref="upload"
          :headers="{ Authorization: 'Bearer ' + token }"
          :action="$uploader.action"
          :show-upload-list="false"
          :on-success="uploadSuccessWorkCard"
          :format="['jpg', 'jpeg', 'png']"
          :on-format-error="handleFormatError"
          :before-upload="$uploader.beforeUpload"
          type="drag"
          style="width: 58px"
        >
          <div style="width: 58px; height: 58px; line-height: 58px">
            <img :src="applyForm.workCard" style="width: 58px; height: 58px; line-height: 58px" v-if="applyForm && applyForm.workCard" />
            <Icon v-else type="shangchuantupian1" :size="20"></Icon>
          </div>
        </Upload>
        <p style="color: #c5c8ce">支持格式：jpg，jpeg，png</p>
      </FormItem>
      <FormItem label="申请理由" prop="reason">
        <Input v-model="applyForm.reason" style="width: 400px" />
      </FormItem>
      <FormItem label="">
        <Button type="primary" @click="applyCompany">申请加入</Button>
      </FormItem>
    </Form>
    <Form
      v-show="mode === 2"
      ref="form"
      :model="form"
      :rules="rules"
      label-position="right"
      :label-width="120"
      style="width: 500px; margin: 0 auto; display: block"
    >
      <FormItem label="企业全称" prop="name">
        <Row typle="flex">
          <Col span="18">
            <Input v-model="form.name" style="width: 280px" readonly />
          </Col>
          <Col>
            <Button type="text" @click="mode = 1">修改企业名称</Button>
          </Col>
        </Row>
      </FormItem>
      <FormItem label="" prop="name" style="display: none"></FormItem>
      <FormItem label="企业Logo" prop="logo">
        <Upload
          ref="upload"
          :headers="{ Authorization: 'Bearer ' + token }"
          :action="$uploader.action"
          :show-upload-list="false"
          :on-success="uploadSuccess"
          :format="['jpg', 'jpeg', 'png']"
          :on-format-error="handleFormatError"
          :before-upload="$uploader.beforeUpload"
          type="drag"
          style="width: 58px"
        >
          <div style="width: 58px; height: 58px; line-height: 58px">
            <img :src="form.logo" style="width: 58px; height: 58px; line-height: 58px" v-if="form && form.logo" />
            <Icon v-else type="shangchuantupian1" :size="20"></Icon>
          </div>
        </Upload>
        <p style="color: #c5c8ce">支持格式：jpg，jpeg，png</p>
      </FormItem>
      <FormItem label="统一社会信用代码" prop="creditCode">
        <Input v-model="form.creditCode" style="width: 400px" />
      </FormItem>
      <FormItem label="企业规模" prop="staffNumRange">
        <Select v-model="form.staffNumRange" style="width: 400px">
          <Option v-for="item in staffNumRange" :value="item" :key="item">{{ item }}</Option>
        </Select>
      </FormItem>
      <FormItem label="所属行业" prop="industry">
        <Select v-model="form.industry" style="width: 400px">
          <Option v-for="item in positions" :value="item" :key="item">{{ item }}</Option>
        </Select>
      </FormItem>
      <FormItem label="企业地址" prop="provinceId">
        <Cascader :data="provinces" :value="cities" style="width: 400px" :load-data="loadData" @on-change="changeCity"></Cascader>
      </FormItem>
      <FormItem prop="address">
        <Input
          v-model="form.address"
          placeholder="选择地址"
          @on-focus="getSite"
          :readonly="!form.lng"
          @on-click="getSite"
          icon="md-locate"
        ></Input>
      </FormItem>

      <FormItem label="是否组建工会">
        <i-switch :true-value="1" :false-value="0" v-model="form.hasUnion">
          <span slot="open">是</span>
          <span slot="close">否</span>
        </i-switch>
      </FormItem>

      <FormItem label="所属管理机构（工会）" v-if="form.hasUnion" prop="unionUuid">
        <Cascader change-on-select :data="topUnions" style="width: 400px" :load-data="getUnions" @on-change="changeUnion"></Cascader>
      </FormItem>

      <FormItem label="企业简介" prop="intro">
        <Input v-model="form.intro" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" style="width: 400px" maxlength="20000" />
      </FormItem>

      <FormItem label="营业执照" prop="businessLicense">
        <Upload
          ref="upload"
          :headers="{ Authorization: 'Bearer ' + token }"
          :action="$uploader.action"
          :show-upload-list="false"
          :on-success="uploadSuccess3"
          :format="['jpg', 'jpeg', 'png']"
          :on-format-error="handleFormatError"
          :before-upload="$uploader.beforeUpload"
          type="drag"
          style="width: 58px"
        >
          <div style="width: 58px; height: 58px; line-height: 58px">
            <img :src="form.businessLicense" style="width: 58px; height: 58px; line-height: 58px" v-if="form && form.businessLicense" />
            <Icon v-else type="shangchuantupian1" :size="20"></Icon>
          </div>
        </Upload>
        <p style="color: #c5c8ce">支持格式：jpg，jpeg，png</p>
      </FormItem>
      <FormItem label="联系人" prop="contactName">
        <Input v-model="form.contactName" placeholder="输入联系人" maxlength="20"></Input>
      </FormItem>
      <FormItem label="移动电话" prop="contactPhone">
        <Input v-model="form.contactPhone" placeholder="输入移动电话"></Input>
      </FormItem>
      <FormItem label="固定电话" prop="landlinePhone">
        <Input v-model="form.landlinePhone" placeholder="输入固定电话"></Input>
      </FormItem>
      <FormItem label="企业邮箱" prop="contactEmail">
        <Input v-model="form.contactEmail" placeholder="输入企业邮箱" maxlength="50"></Input>
      </FormItem>
      <!-- <FormItem label="企业相册">
        <Row type="flex">
          <div
            class="demo-upload-list"
            style="width: 58px; height: 58px; line-height: 58px"
            v-for="(item, index) in form.images"
            :key="item.url"
          >
            <img :src="item.url" />
            <div class="demo-upload-list-cover">
              <Icon type="trash" @click.native="handleRemove(index)" color="#fff"></Icon>
            </div>
          </div>
          <Upload
            ref="upload"
            :headers="{ Authorization: 'Bearer ' + token }"
            :action="$uploader.action"
            :show-upload-list="false"
            :on-success="uploadSuccess2"
            :format="['jpg', 'jpeg', 'png']"
            :before-upload="$uploader.beforeUpload"
            :default-file-list="form.images"
            multiple
            type="drag"
            style="width: 58px; height: 58px; line-height: 58px"
          >
            <div style="width: 58px; height: 58px; line-height: 58px">
              <Icon type="shangchuantupian1" :size="20"></Icon>
            </div>
          </Upload>
        </Row>
      </FormItem> -->
      <FormItem>
        <Button type="primary" @click="save">提交审核</Button>
      </FormItem>
    </Form>
    <Drawer title="地图" width="500" :closable="true" :mask-closable="false" v-model="oMap">
      <Map @setSite="setSite"></Map>
    </Drawer>
  </div>
</template>

<script>
import Map from '@/components/map/map';
import { mapActions } from 'vuex';
export default {
  name: '',
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  components: {
    Map
  },
  data() {
    return {
      mode: 1,
      form: {},
      rules1: {
        name: [{ required: true, message: '企业名称必填', trigger: 'blur' }]
      },
      rules: {
        name: [{ required: true, message: '企业名称必填', trigger: 'blur' }],
        creditCode: [{ required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }],
        logo: [{ required: true, message: 'logo不能为空', trigger: 'blur' }],
        provinceId: [{ required: true, message: '省份不能为空', trigger: 'blur' }],
        cityId: [{ required: true, message: '城市不能为空', trigger: 'blur' }],
        address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
        intro: [{ required: true, message: '企业简介不能为空', trigger: 'blur' }],
        contactName: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
        contactPhone: [
          { required: true, message: '联系人电话不能为空', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        // landlinePhone: [{ pattern: /^(0\d{2,3})-?(\d{7,8})$/, message: '请输入正确的固定电话格式', trigger: 'blur' }],
        landlinePhone: [{ pattern: /^.{1,15}$/, message: '请输入正确的固定电话格式', trigger: 'blur' }],
        unionId: [{ required: true, message: '所属工会不能为空', trigger: 'blur' }],
        hasUnion: [{ required: true, message: '是否组建工会不能为空', trigger: 'blur' }],
        unionUuid: [{ required: true, message: '工会不能为空', trigger: 'blur' }],
        staffNumRange: [{ required: true, message: '企业规模不能为空', trigger: 'blur' }],
        industry: [{ required: true, message: '所属行业不能为空', trigger: 'blur' }],
        businessLicense: [{ required: true, message: '营业执照不能为空', trigger: 'blur' }]
      },
      provinces: [],
      cities: [],
      oMap: false,
      topUnions: [],
      applyForm: {},
      applyRules: {},
      staffNumRange: ['0-20人', '20-99人', '100-499人', '500-999人', '1000-9999人', '10000人以上'],
      positions: [
        '农、林、牧、渔业',
        '采矿业',
        '制造业',
        '电力、热力、燃气及水生产和供应业',
        '建筑业',
        '批发和零售业',
        '交通运输、仓储和邮政业',
        '住宿和餐饮业',
        '信息传输、软件和信息技术服务业',
        '金融业',
        '房地产业',
        '租赁和商务服务业',
        '科学研究和技术服务业',
        '水利、环境和公共设施管理业',
        '居民服务、修理和其他服务业',
        '教育',
        '卫生和社会工作',
        '文化、体育和娱乐业',
        '公共管理、社会保障和社会组织',
        '国际组织'
      ]
    };
  },
  mounted() {
    this.getProvinces();
    this.getUnions();
    // this.getPositions();
  },
  methods: {
    ...mapActions(['getUserInfo']),
    applyCompany() {
      this.$axios
        .request({
          url: 'front/v1/companyFront/applyCompany',
          method: 'post',
          data: this.applyForm,
          headers: { Authorization: 'Bearer ' + this.token }
        })
        .then(res => {
          if (res.data) {
            this.$store.commit('setToken', res.data);
            this.getUserInfo().then(res => {
              this.$router.push({
                name: 'zhiweiIndex'
              });
            });
          } else {
            this.$Modal.confirm({
              title: '提示',
              content: '申请成功，等待企业主管理审核',
              onOk: () => {
                this.mode = 3;
                this.applyForm.companyId = res.data;
                this.$emit('finish');
              }
            });
          }
        });
    },

    checkCompany() {
      this.$refs.mainForm.validate(valid => {
        if (valid) {
          this.$axios
            .request({
              url: 'front/v1/companyFront/checkCompanyName',
              params: {
                name: this.form.name
              },
              headers: { Authorization: 'Bearer ' + this.token }
            })
            .then(res => {
              if (!res.data) {
                this.$Modal.confirm({
                  title: '提示',
                  content: '该企业还未认证，请先填写认证信息',
                  onOk: () => {
                    this.mode = 2;
                  }
                });
              } else {
                this.$Modal.confirm({
                  title: '提示',
                  content: '点击确认填写申请理由',
                  onOk: () => {
                    this.mode = 3;
                    this.applyForm.companyId = res.data;
                  }
                });
              }
            });
        }
      });
    },
    processData(items) {
      let res = [];
      items.forEach(item => {
        let data = {
          label: item.deptName,
          value: item.uuid
        };
        if (item.hasChildren) {
          data = {
            label: item.deptName,
            value: item.uuid,
            loading: false,
            children: []
          };
        }
        res.push(data);
      });
      return res;
    },
    getUnions(item, callback) {
      if (item) {
        item.loading = true;
      }
      this.$axios
        .request({
          url: 'front/v1/common/union/uuid',
          params: { uuid: item ? item.value : '0' },
          headers: { Authorization: 'Bearer ' + this.token }
        })
        .then(res => {
          let children = this.processData(res.data);
          if (item) {
            item.loading = false;
            item.children = children;
            this.$set(this.form, 'unionUuid', item.value);
            callback();
          } else {
            this.topUnions = children;
          }
        });
    },
    uploadSuccess2(res, file) {
      file.url = res.data.url;
      file.name = res.data.name;
      if (!this.form.images) {
        this.$set(this.form, 'images', []);
      }
      this.form.images.push({
        url: res.data.url,
        name: res.data.name
      });
    },
    handleRemove(index) {
      this.form.images.splice(index, 1);
    },
    save() {
      this.$refs.form.validate(ok => {
        if (ok) {
          this.$Modal.confirm({
            title: '提示',
            content: '确定要提交信息么',
            onOk: () => {
              setTimeout(() => {
                this._doSave();
              }, 1000);
            }
          });
        }
      });
    },
    _doSave() {
      this.$axios
        .request({
          url: 'front/v1/companyFront',
          method: 'post',
          data: this.form,
          headers: { Authorization: 'Bearer ' + this.token }
        })
        .then(res => {
          this.$Modal.success({
            title: '提示',
            content: '提交成功，等待审核',
            onOk: () => {
              setTimeout(() => {
                this.$emit('finish');
              }, 1000);
            }
          });
        });
    },
    getProvinces() {
      this.$axios
        .request({
          url: 'front/v1/area/province',
          method: 'get'
        })
        .then(res => {
          this.provinces = [];
          res.data.forEach(item => {
            this.provinces.push({ value: item.value, label: item.label, children: [], loading: false });
          });
        });
    },
    changePhone(value) {
      this.$set(this.form, 'contactPhone', value);
    },
    getSite() {
      this.oMap = true;
    },
    setSite(e) {
      this.oMap = false;
      this.$set(this.form, 'lat', e.latlng.lat);
      this.$set(this.form, 'lng', e.latlng.lng);
      this.$set(this.form, 'address', e.poiaddress);
    },
    loadData(item, callback) {
      item.loading = true;
      this.$axios
        .request({
          url: 'front/v1/area/district/' + item.value,
          method: 'get'
        })
        .then(res => {
          item.loading = false;
          item.children = res.data;
          callback();
        });
    },
    changeCity(value) {
      this.cities = value;
      this.$set(this.form, 'provinceId', value[0]);
      this.$set(this.form, 'cityId', value[1]);
      this.$set(this.form, 'districtId', value[2]);
      this.$set(this.form, 'streetId', value[3]);
    },
    changeUnion(value) {
      if (value) {
        this.$set(this.form, 'unionUuid', value[value.length - 1]);
      } else {
        this.$set(this.form, 'unionUuid', 0);
      }
    },
    handleFormatError() {
      this.$Message.error({
        content: '暂不支持格式类型'
      });
    },
    uploadSuccess(res) {
      this.$set(this.form, 'logo', res.data.url);
    },
    uploadSuccess3(res) {
      this.$set(this.form, 'businessLicense', res.data.url);
    },
    uploadSuccessWorkCard(res) {
      this.$set(this.applyForm, 'workCard', res.data.url);
    },
    getPositions() {
      this.$axios.request({ url: 'front/v1/position/tree' }).then(res => {
        this.positions = res.data;
      });
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep .ivu-drawer-wrap {
  z-index: 10000;
}
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>
